/**
 * [TLG]: precio total (variante seleccionada x cantidad) dentro del boton de anadir al carrito.
 *
 * Se registra como custom element a proposito: el connectedCallback se dispara cada vez que el
 * elemento entra en el DOM, asi que tambien funciona en el quick view y el quick shop, que el tema
 * inyecta por AJAX mucho despues de DOMContentLoaded.
 *
 * Lo usa el snippet tlg-product-total-price.liquid.
 */
(function () {
  'use strict';

  var TAG_NAME = 'tlg-total-price';

  if (!window.customElements || customElements.get(TAG_NAME)) return;

  var MONEY_PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;
  var DEFAULT_MONEY_FORMAT = '{{amount}}';

  /**
   * El tema ya expone un formateador que respeta la configuracion de moneda de la tienda
   * (separadores, decimales, codigo ISO). Solo formateamos por nuestra cuenta si todavia no
   * esta cargado theme.min.js.
   */
  function formatMoney(cents, format) {
    var currency = window.T4SThemeSP && window.T4SThemeSP.Currency;

    if (currency && typeof currency.formatMoney === 'function') {
      return currency.formatMoney(cents, format);
    }

    return fallbackFormatMoney(cents, format);
  }

  function fallbackFormatMoney(cents, format) {
    var match = format.match(MONEY_PLACEHOLDER);
    var name = match ? match[1] : 'amount';
    var decimals = name.indexOf('no_decimals') === -1 ? 2 : 0;
    var thousands = ',';
    var decimal = '.';

    if (name.indexOf('comma_separator') !== -1) {
      thousands = '.';
      decimal = ',';
    } else if (name.indexOf('space_separator') !== -1) {
      thousands = ' ';
      decimal = ',';
    }

    var parts = (cents / 100).toFixed(decimals).split('.');
    var integer = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var amount = parts[1] ? integer + decimal + parts[1] : integer;

    return format.replace(MONEY_PLACEHOLDER, function () {
      return amount;
    });
  }

  class TlgTotalPrice extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.output = this.querySelector('[data-tlg-total-price-output]');
      this.prices = this.readPrices();

      if (!this.form || !this.output || !this.prices) return;

      this.moneyFormat =
        this.getAttribute('data-tlg-money-format') ||
        (window.T4Sconfigs && window.T4Sconfigs.moneyFormat) ||
        DEFAULT_MONEY_FORMAT;

      this.handleFieldChange = this.handleFieldChange.bind(this);
      this.handleQuantityStep = this.handleQuantityStep.bind(this);

      // El tema emite un change nativo sobre [name="id"] al pulsar un swatch, asi que basta
      // con escuchar en el formulario. Delegamos para sobrevivir a que el tema reemplace nodos.
      this.form.addEventListener('change', this.handleFieldChange);
      this.form.addEventListener('input', this.handleFieldChange);
      this.form.addEventListener('click', this.handleQuantityStep);

      this.render();
    }

    disconnectedCallback() {
      if (!this.form) return;

      this.form.removeEventListener('change', this.handleFieldChange);
      this.form.removeEventListener('input', this.handleFieldChange);
      this.form.removeEventListener('click', this.handleQuantityStep);
    }

    readPrices() {
      var source = this.querySelector('[data-tlg-variant-prices]');

      if (!source) return null;

      try {
        return JSON.parse(source.textContent);
      } catch (error) {
        return null;
      }
    }

    handleFieldChange(event) {
      var name = event.target && event.target.name;

      if (name !== 'id' && name !== 'quantity') return;

      this.render();
    }

    /**
     * Los botones +/- de cantidad del tema escriben el value y lanzan un change de jQuery, que
     * no alcanza a los listeners nativos. Releemos en el siguiente tick, ya con el valor final,
     * en lugar de incrementar nosotros (eso contaria el clic dos veces).
     */
    handleQuantityStep(event) {
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest('[data-quantity-selector]')) return;

      window.setTimeout(this.render.bind(this), 0);
    }

    get quantity() {
      var input = this.form.querySelector('[name="quantity"]');
      var value = parseInt(input && input.value, 10);

      return value > 0 ? value : 1;
    }

    get variantId() {
      var input = this.form.querySelector('[name="id"]');

      return input ? input.value : null;
    }

    render() {
      var price = this.prices[this.variantId];

      if (typeof price !== 'number') return;

      this.output.innerHTML = formatMoney(price * this.quantity, this.moneyFormat);
    }
  }

  customElements.define(TAG_NAME, TlgTotalPrice);
})();
